/**
 * Location-related constants for consistent text across the application
 */

export const LOCATION_TEXT = {
  DEFAULT: 'All of New Zealand',
  SELECTED_LOCATION: 'Selected location',
  ALL_DISTRICTS: 'All districts',
  ALL_LOCATIONS: 'All locations across New Zealand',
};

export const LOCATION_CONFIG = {
  STORAGE_KEY: 'supergold_selected_location',
  STORAGE_EXPIRY_MS: 24 * 60 * 60 * 1000, // 24 hours
  ADDRESS_MAX_LENGTH: 100,
  DEFAULT_RADIUS_KM: 25,
};